<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card :title="$t('labels.latest_projects')">
          <div slot="no-body">
            <vs-table :data="projectData" class="table-dark-inverted p-6">
              <template slot="thead">
                <vs-th class="font-semibold col-md-2">{{
                  $t("labels.name")
                }}</vs-th>
                <vs-th class="font-semibold col-md-2">{{
                  $t("labels.vessel")
                }}</vs-th>
                <vs-th class="font-semibold col-md-2">
                  {{ $t("labels.project_status") }}
                </vs-th>
                <vs-th class="font-semibold col-md-2">
                  {{ $t("labels.consultants") }}
                </vs-th>
                <vs-th class="font-semibold col-md-2">{{
                  $t("labels.reviewer")
                }}</vs-th>
                <vs-th class="font-semibold col-md-2">
                  {{ $t("labels.start_date") }}
                </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.project_name">
                    <router-link
                      class="view-link"
                      :to="{ name: 'ViewProject', params: { id: tr.id } }"
                      v-if="checkPermission('project', 'view')"
                      >{{ tr.name }}</router-link
                    >
                  </vs-td>
                  <vs-td :data="tr.project_name">
                    <router-link
                      class="view-link"
                      :to="{ name: 'ViewVessel', params: { id: tr.vessel_id } }"
                      v-if="checkPermission('vessel', 'view')"
                      >{{ tr.vessel.name }}</router-link
                    >
                  </vs-td>
                  <vs-td :data="tr.project_name">
                    <span>{{ tr.status_name }}</span>
                  </vs-td>

                  <vs-td
                    :data="tr.project_name"
                    v-if="$store.state.userInfo.type === 'A'"
                  >
                    <ul class="users-liked user-list">
                      <li
                        v-for="(user, userIndex) in tr.consultants"
                        :key="userIndex"
                      >
                        <router-link
                          class="view-link"
                          :to="{ name: 'ViewUser', params: { id: user.id } }"
                          v-if="checkPermission('user', 'view')"
                        >
                          <vs-avatar
                            :text="user.name"
                            size="30px"
                            class="border-2 border-white border-solid -m-1"
                          ></vs-avatar>
                        </router-link>
                      </li>
                    </ul>
                  </vs-td>

                  <vs-td
                    :data="tr.project_name"
                    v-if="$store.state.userInfo.type !== 'A'"
                  >
                    <ul class="users-liked user-list">
                      <li
                        v-for="(user, userIndex) in tr.consultants"
                        :key="userIndex"
                      >
                        <vs-avatar
                          :text="user.name"
                          size="30px"
                          class="border-2 border-white border-solid -m-1"
                        ></vs-avatar>
                      </li>
                    </ul>
                  </vs-td>

                  <vs-td
                    :data="tr.project_name"
                    v-if="$store.state.userInfo.type === 'A'"
                  >
                    <router-link
                      class="view-link"
                      :to="{ name: 'ViewUser', params: { id: tr.reviewer.id } }"
                      v-if="checkPermission('user', 'view')"
                      >{{ tr.reviewer.name }}</router-link
                    >
                  </vs-td>

                  <vs-td
                    :data="tr.project_name"
                    v-if="$store.state.userInfo.type !== 'A'"
                  >
                    <span>{{ tr.reviewer.name }}</span>
                  </vs-td>
                  <vs-td :data="tr.project_name">
                    <span>{{ tr.date | only_date_format }}</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    VueApexCharts,
  },
  data() {
    return {
      input: {},
      projectData: [],
    };
  },
  async mounted() {
    this.getDashboardProjectsData();
  },
  methods: {
    async getDashboardProjectsData() {
      let response = await this.getHTTPPostResponse(
        "/dashboard/latest-projects",
        this.input
      );
      if (response) {
        var consultant_Str = "";
        let data_response = response.data["latest_projects"];
        this.projectData = data_response;
      }
    },
  },
};
</script>
<style scoped>
.user-list .con-vs-avatar:hover {
  background: rgba(var(--vs-dark), 1) !important;
}
</style>
